import { Immutable } from "immer";
import React from "react";
import { prefillSSRRetailData } from "tsi-common-react/src/apps/retail/ssr";
import { useSSRStorePrefill } from "tsi-common-react/src/store/reducers";
import { t } from "ttag";

import { templates } from "@reactivated";

import { LocatorFilters } from "../LocatorFilters";
import { LocatorNearestStores } from "../LocatorNearestStores";
import { LocatorQuickSearch } from "../LocatorQuickSearch";

// TODO: These wrapper classes (locator, quicksearch, filters, locations, etc.)
// use global SCSS from retail-locator.scss and retail-locator-modules.scss.
// The child components (LocatorQuickSearch, LocatorFilters, LocatorNearestStores)
// also reference these global BEM classes as string literals. A future refactor
// should convert the entire retail locator component tree to CSS Modules
// simultaneously — doing it piecemeal would break the BEM cascade.

type IProps = Immutable<templates.RetailLocatorPage2Template["page"]>;

export const RetailLocatorPageSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            hide_elite: props.hide_elite,
            hide_tp_stores: props.hide_tp_stores,
        },
        prefillSSRRetailData,
    );

    return (
        <div className="locator">
            <div className="quicksearch">
                <div className="quicksearch__title-bar">
                    <h1 className="quicksearch__title">
                        {t`Find a Tempur-Pedic\u00AE Retailer`}
                    </h1>
                </div>
                <div className="quicksearch__wrapper">
                    <h2 className="quicksearch__headline">{t`Quick Search`}</h2>
                    <div className="l-capped-width">
                        <LocatorQuickSearch
                            hideElite={props.hide_elite}
                            hideTpStores={props.hide_tp_stores}
                        />
                    </div>
                </div>
            </div>
            <section className="default-form-container bh-sl-form-container filters l-capped-width">
                <LocatorFilters />
            </section>
            <section className="locations l-capped-width">
                <LocatorNearestStores />
            </section>
        </div>
    );
};
